module.exports = __webpack_public_path__ + "static/media/video_image1.067e6c2c.svg";